import { atom } from 'recoil';

export const LANG_KO = 0;
export const LANG_EN = 1;
export const LANG_CH = 2;
export const LANG_JP = 3;
export const LANG_TH = 4;
export const LANG_ES = 5;
export const LANG_FR = 6;
export const LANG_RU = 7;
export const LANG_DE = 8;

type LangStringArrayType = [string, string, string, string, string, string, string, string, string];

export const langState = atom<number>({
  key: 'lang',
  default: LANG_KO,
});

export const langText: Record<string, LangStringArrayType> = {
  main_title: [
    '구매 내역',
    'Purchase history',
    '购买明细',
    '購買内訳',
    'ประวัติการซื้อ.',
    'historia de compras',
    "détail d'un achat.",
    'История покупки',
    'Geschichte des Kaufs',
  ],
  order_waiting_title: [
    '주문 접수',
    'Order received',
    '订单已接收',
    '注文を受け付けました',
    'ได้รับคำสั่งซื้อแล้ว',
    'Pedido recibido',
    'Commande reçue',
    'Заказ принят',
    'Bestellung erhalten',
  ],
  order_waiting_sub_title: [
    '주문이 확정된 것은 아니니\n확정 안내를 받은 후 구매처로 방문해주세요.',
    'Your order is not confirmed yet.\nPlease visit the retailer after receiving the confirmation.',
    '您的订单尚未确认。\n请在收到确认后前往购买处。',
    'ご注文はまだ確定していません。\n確認通知を受け取った後、購入先に訪問してください。',
    'คำสั่งซื้อของคุณยังไม่ได้รับการยืนยัน\nกรุณาไปยังสถานที่ซื้อหลังจากได้รับการยืนยัน',
    'Su pedido no está confirmado.\nVisite el punto de venta después de recibir la confirmación.',
    "Votre commande n'est pas encore confirmée.\nVeuillez vous rendre chez le détaillant après avoir reçu la confirmation.",
    'Ваш заказ еще не подтвержден.\nПожалуйста, посетите место покупки после получения подтверждения.',
    'Ihre Bestellung ist noch nicht bestätigt.\nBitte besuchen Sie den Händler, nachdem Sie die Bestätigung erhalten haben.',
  ],
  order_ready_title: [
    '예약완료',
    'Reservation completed',
    '预订完成',
    '予約完了',
    'จองเสร็จแล้ว',
    'Reserva completada',
    'Réservation terminée',
    'Бронирование завершено',
    'Reservierung abgeschlossen',
  ],
  order_ready_sub_title: [
    '주문이 확정되었습니다',
    'Your order has been confirmed',
    '您的订单已确认',
    'ご注文が確定しました',
    'คำสั่งซื้อของคุณได้รับการยืนยันแล้ว',
    'Su pedido ha sido confirmado',
    'Votre commande a été confirmée',
    'Ваш заказ подтвержден',
    'Ihre Bestellung wurde bestätigt',
  ],
  order_cancel_title: [
    '주문 취소 완료',
    'Order cancellation completed',
    '订单取消完成',
    '注文キャンセル完了',
    'ยกเลิกคำสั่งซื้อเรียบร้อยแล้ว',
    'Cancelación de pedido completada',
    'Annulation de commande terminée',
    'Отмена заказа завершена',
    'Stornierung der Bestellung abgeschlossen',
  ],
  order_cancel_sub_title: [
    '주문 취소가 완료되었어요',
    'Your order cancellation has been completed',
    '您的订单取消已完成',
    'ご注文のキャンセルが完了しました',
    'การยกเลิกคำสั่งซื้อของคุณเสร็จเรียบร้อยแล้ว',
    'La cancelación de su pedido se ha completado',
    "L'annulation de votre commande est terminée",
    'Ваш заказ отменён',
    'Ihre Bestellung wurde storniert',
  ],
  order_success_title: [
    '사용 완료',
    'Usage completed',
    '使用完成',
    '使用完了',
    'การใช้งานเสร็จสิ้น',
    'Uso completado',
    'Utilisation terminée',
    'Использование завершено',
    'Nutzung abgeschlossen',
  ],
  order_success_sub_title: [
    '사용 완료 처리되었습니다',
    'Usage completed and processed',
    '使用完成并已处理',
    '使用完了，已处理',
    'การใช้งานเสร็จสิ้นและได้ดำเนินการ',
    'Uso completado y procesado',
    'Utilisation terminée et traitée',
    'Использование завершено и обработано',
    'Nutzung abgeschlossen und verarbeitet',
  ],
  cancel_order: [
    '취소 요청하기',
    'Request cancellation',
    '请求取消',
    'キャンセルをリクエスト',
    'ขอเรียกคืน',
    'Solicitar cancelación',
    "Demander l'annulation",
    'Запросить отмену',
    'Stornierung anfordern',
  ],
  cancel_modal_title: [
    '주문 취소 확인',
    'Order cancellation confirmation',
    '订单取消确认',
    '注文キャンセル確認',
    'ยืนยันการยกเลิกคำสั่งซื้อ',
    'Confirmación de cancelación de pedido',
    "Confirmation de l'annulation de la commande",
    'Подтверждение отмены заказа',
    'Bestätigung der Stornierung der Bestellung',
  ],
  cancel_modal_content: [
    '정말로 주문을 취소하시겠어요?\n한 번 취소된 주문은 되돌릴 수 없어요.',
    'Are you sure you want to cancel the order? \nOnce canceled, the order cannot be reversed.',
    '您真的要取消订单吗？\n一旦取消，订单将无法恢复。',
    '本当に注文をキャンセルしますか？\n一度キャンセルされた注文は元に戻せません。',
    'คุณแน่ใจหรือว่าต้องการยกเลิกคำสั่งซื้อ?\nคำสั่งซื้อที่ถูกยกเลิกแล้วจะไม่สามารถกลับคืนได้。',
    '¿Está seguro de que desea cancelar el pedido?\nUna vez cancelado, el pedido no se puede revertir.',
    'Êtes-vous sûr de vouloir annuler la commande ? \nUne fois annulée, la commande ne peut pas être inversée.',
    'Вы действительно хотите отменить заказ? \nПосле отмены заказ не может быть восстановлен.',
    'Sind Sie sicher, dass Sie die Bestellung stornieren möchten? \nEinmal storniert, kann die Bestellung nicht zurückgesetzt werden.',
  ],
  cancel_success_button: [
    '취소 신청',
    'Cancellation request',
    '取消申请',
    'キャンセル申請',
    'คำขอยกเลิก',
    'Solicitud de cancelación',
    "Demande d'annulation",
    'Запрос на отмену',
    'Stornierungsantrag',
  ],
  order_cancel_request: [
    '주문 취소 요청',
    'Order cancellation request',
    '订单取消请求',
    '注文キャンセルリクエスト',
    'คำขอยกเลิกคำสั่งซื้อ',
    'Solicitud de cancelación de pedido',
    "Demande d'annulation de commande",
    'Запрос на отмену заказа',
    'Antrag auf Stornierung der Bestellung',
  ],
  order_cancel_request_text: [
    '주문 취소가 접수될 때까지\n잠시만 기다려 주세요.',
    'Please wait while your order cancellation is being processed.',
    '订单取消正在处理中，请稍等。',
    '注文キャンセルが処理されるまで\n少々お待ちください。',
    'กรุณารอซักครู่ขณะที่การยกเลิกคำสั่งซื้อของคุณกำลังดำเนินการอยู่',
    'Espere un momento mientras se procesa la cancelación de su pedido.',
    "Veuillez patienter pendant que l'annulation de votre commande est en cours.",
    'Пожалуйста, подождите, пока ваш заказ отменяется.',
    'Bitte warten Sie, während die Stornierung Ihrer Bestellung bearbeitet wird.',
  ],
  order_checking: [
    '주문을 확인하고 있어요',
    'Checking your order',
    '正在确认您的订单',
    'ご注文を確認しています',
    'กำลังตรวจสอบคำสั่งซื้อของคุณ',
    'Estamos verificando su pedido',
    'Nous vérifions votre commande',
    'Мы проверяем ваш заказ',
    'Ihre Bestellung wird überprüft',
  ],
  cancellation_unavailable: [
    '접수가 완료되면 취소가 불가능해요',
    'Cancellation is not possible once the order is confirmed',
    '订单确认后无法取消',
    '注文が確定するとキャンセルはできません',
    'ไม่สามารถยกเลิกได้เมื่อยืนยันคำสั่งซื้อแล้ว',
    'La cancelación no es posible una vez confirmado el pedido',
    "L'annulation n'est pas possible une fois la commande confirmée",
    'Отмена невозможна после подтверждения заказа',
    'Eine Stornierung ist nach Bestätigung der Bestellung nicht möglich',
  ],
  order_in_progress: [
    '주문 확인중',
    'Order in progress',
    '订单确认中',
    '注文確認中',
    'กำลังตรวจสอบคำสั่งซื้อ',
    'Pedido en progreso',
    'Commande en cours',
    'Заказ в обработке',
    'Bestellung wird überprüft',
  ],
  preparing: [
    '조리중',
    'Preparing',
    '准备中',
    '調理中',
    'กำลังเตรียม',
    'Preparando',
    'En préparation',
    'Готовится',
    'In Vorbereitung',
  ],
  food_preparing: [
    '음식을 정성껏 조리중이에요',
    'We are carefully preparing your food',
    '正在精心准备您的食物',
    '料理を丁寧に準備しています',
    'กำลังเตรียมอาหารของคุณอย่างใส่ใจ',
    'Estamos preparando su comida con esmero',
    'Nous préparons votre repas avec soin',
    'Мы тщательно готовим вашу еду',
    'Wir bereiten Ihr Essen sorgfältig zu',
  ],
  preparation_complete: [
    '조리가 완료되었어요',
    'Preparation is complete',
    '准备完成了',
    '調理が完了しました',
    'การเตรียมเสร็จสมบูรณ์แล้ว',
    'La preparación está completa',
    'La préparation est terminée',
    'Приготовление завершено',
    'Die Zubereitung ist abgeschlossen',
  ],

  order_cancelled: [
    '주문이 취소되었어요',
    'Your order has been cancelled',
    '您的订单已取消',
    'ご注文がキャンセルされました',
    'คำสั่งซื้อของคุณถูกยกเลิกแล้ว',
    'Su pedido ha sido cancelado',
    'Votre commande a été annulée',
    'Ваш заказ был отменен',
    'Ihre Bestellung wurde storniert',
  ],
  delivery_unavailable: [
    '현재 배달이 어려워요\n죄송하지만 다른 매장 이용 부탁드릴게요',
    'Delivery is currently unavailable.\nWe apologize and ask that you please use another store.',
    '目前无法配送。\n抱歉，请您使用其他店铺。',
    '現在、配達が困難です。\n申し訳ございませんが、他の店舗をご利用ください。',
    'ขณะนี้ไม่สามารถจัดส่งได้\nขออภัยโปรดใช้ร้านอื่น',
    'La entrega no está disponible en este momento.\nLe pedimos disculpas y le solicitamos que utilice otra tienda.',
    'La livraison est actuellement indisponible.\nNous vous prions de bien vouloir utiliser un autre magasin.',
    'В настоящее время доставка невозможна.\nПожалуйста, воспользуйтесь другим магазином.',
    'Lieferung ist derzeit nicht möglich.\nBitte nutzen Sie ein anderes Geschäft.',
  ],
  reason_label: ['사유', 'Reason', '原因', '理由', 'เหตุผล', 'Razón', 'Raison', 'Причина', 'Grund'],
  food_delivery_safe: [
    '음식을 안전하게 배달중이에요',
    'Delivering your food safely',
    '正在安全配送您的食物',
    '安全に料理を配達中です',
    'กำลังจัดส่งอาหารของคุณอย่างปลอดภัย',
    'Estamos entregando su comida de manera segura',
    'Nous livrons votre nourriture en toute sécurité',
    'Мы безопасно доставляем вашу еду',
    'Wir liefern Ihr Essen sicher',
  ],
  delivery_in_progress: [
    '배달중',
    'In delivery',
    '配送中',
    '配達中',
    'กำลังจัดส่ง',
    'En entrega',
    'En cours de livraison',
    'В доставке',
    'Lieferung läuft',
  ],
  item_arrived: [
    '상품이 도착했어요',
    'Your item has arrived',
    '您的商品已到达',
    '商品が到着しました',
    'สินค้ามาถึงแล้ว',
    'Su artículo ha llegado',
    'Votre article est arrivé',
    'Ваш товар прибыл',
    'Das Produkt ist angekommen',
  ],
  item_delivered: [
    '배달장소에 상품이 도착했어요\n상품을 수령해주세요',
    'Your item has arrived at the delivery location.\nPlease collect your item.',
    '您的商品已到达配送地点。\n请领取您的商品。',
    '配達場所に商品が到着しました。\n商品を受け取ってください。',
    'สินค้ามาถึงที่จุดจัดส่งแล้ว\nกรุณารับสินค้าของคุณ',
    'Su artículo ha llegado al lugar de entrega.\nPor favor, recoja su artículo.',
    'Votre article est arrivé au lieu de livraison.\nVeuillez récupérer votre article.',
    'Ваш товар прибыл в пункт доставки.\nПожалуйста, получите ваш товар.',
    'Das Produkt ist am Lieferort angekommen.\nBitte holen Sie Ihr Produkt ab.',
  ],
  order_confirmation: [
    '주문확인',
    'Order Confirmation',
    '订单确认',
    '注文確認',
    'ตรวจสอบคำสั่งซื้อ',
    'Confirmación de Pedido',
    'Confirmation de Commande',
    'Подтверждение заказа',
    'Bestellbestätigung',
  ],
  cooking_in_progress: [
    '조리중',
    'Cooking in progress',
    '烹饪中',
    '調理中',
    'กำลังปรุงอาหาร',
    'Cocinando',
    'En cuisson',
    'Приготовление',
    'Kochen',
  ],
  cooking_complete: [
    '조리완료',
    'Cooking complete',
    '烹饪完成',
    '調理完了',
    'การปรุงอาหารเสร็จสมบูรณ์',
    'Cocción completa',
    'Cuisson terminée',
    'Приготовление завершено',
    'Kochen abgeschlossen',
  ],
  delivery_complete: [
    '배달완료',
    'Delivery complete',
    '配送完成',
    '配達完了',
    'การจัดส่งเสร็จสมบูรณ์',
    'Entrega completa',
    'Livraison terminée',
    'Доставка завершена',
    'Lieferung abgeschlossen',
  ],
  order_special_requests: [
    '주문 시 요청사항',
    'Special requests for the order',
    '订单时的特殊请求',
    '注文時の特別リクエスト',
    'คำขอพิเศษสำหรับการสั่งซื้อ',
    'Solicitudes especiales para el pedido',
    'Demandes spéciales pour la commande',
    'Специальные запросы к заказу',
    'Besondere Anfragen zur Bestellung',
  ],
  count_unit: ['개', 'pieces', '个', '個', 'ชิ้น', 'piezas', 'pièces', 'шт.', 'Stück'],
  knock_knock_delivery_status: [
    '노크노크 배달현황 안내',
    'Knock Knock Delivery Status Guide',
    '诺克诺克配送状态指南',
    'ノックノック配達状況ガイド',
    'โน้กโน้กสถานะการจัดส่ง',
    'Guía de estado de entrega Knock Knock',
    'Guide de statut de livraison Knock Knock',
    'Руководство по статусу доставки Knock Knock',
    'Knock Knock Lieferstatus Anleitung',
  ],
  delivery_status_update: [
    '배달 현황 업데이트',
    'Delivery Status Update',
    '配送状态更新',
    '配達状況の更新',
    'อัปเดตสถานะการจัดส่ง',
    'Actualización del estado de entrega',
    'Mise à jour du statut de livraison',
    'Обновление статуса доставки',
    'Lieferstatus-Update',
  ],
  cancel_action: [
    '취소 하기',
    'Cancel',
    '取消',
    'キャンセル',
    'ยกเลิก',
    'Cancelar',
    'Annuler',
    'Отменить',
    'Stornieren',
  ],
  order_history: [
    '주문 내역',
    'Order History',
    '订单历史',
    '注文履歴',
    'ประวัติการสั่งซื้อ',
    'Historial de pedidos',
    'Historique des commandes',
    'История заказов',
    'Bestellverlauf',
  ],
  product_amount: [
    '상품금액',
    'Product Amount',
    '商品金额',
    '商品の金額',
    'จำนวนเงินสินค้า',
    'Monto del producto',
    'Montant du produit',
    'Сумма товара',
    'Produktbetrag',
  ],
  delivery_tip: [
    '배달팁',
    'Delivery Tip',
    '配送小费',
    '配達チップ',
    'ค่าทิปการจัดส่ง',
    'Propina de entrega',
    'Pourboire de livraison',
    'Чаевые за доставку',
    'Liefergebühr',
  ],
  discount_amount: [
    '할인금액',
    'Discount Amount',
    '折扣金额',
    '割引金額',
    'จำนวนเงินส่วนลด',
    'Monto del descuento',
    'Montant de la remise',
    'Сумма скидки',
    'Rabattbetrag',
  ],
  product_discount: [
    '상품할인',
    'Product Discount',
    '商品折扣',
    '商品の割引',
    'ส่วนลดสินค้า',
    'Descuento del producto',
    'Remise sur le produit',
    'Скидка на товар',
    'Produkt-Rabatt',
  ],
  coupon_discount: [
    '쿠폰할인',
    'Coupon Discount',
    '优惠券折扣',
    'クーポン割引',
    'ส่วนลดจากคูปอง',
    'Descuento de cupón',
    'Remise de coupon',
    'Скидка по купону',
    'Gutscheinrabatt',
  ],
  payment_amount: [
    '결제금액',
    'Payment Amount',
    '付款金额',
    '支払金額',
    'จำนวนเงินที่ต้องชำระ',
    'Monto a pagar',
    'Montant à payer',
    'Сумма платежа',
    'Zahlungsbetrag',
  ],
  customer_service: [
    '고객센터',
    'Customer Service',
    '客服中心',
    'カスタマーサービス',
    'บริการลูกค้า',
    'Servicio al Cliente',
    'Service Client',
    'Служба поддержки клиентов',
    'Kundenservice',
  ],
  satisfaction_feedback: [
    '만족도 평가를 남겨주세요',
    'Please leave your satisfaction rating',
    '请留下您的满意度评价',
    '満足度評価を残してください',
    'โปรดให้คะแนนความพึงพอใจของคุณ',
    'Por favor, deje su evaluación de satisfacción',
    'Veuillez laisser votre évaluation de satisfaction',
    'Пожалуйста, оставьте свою оценку удовлетворенности',
    'Bitte hinterlassen Sie Ihre Zufriedenheitsbewertung',
  ],
  food_satisfaction: [
    '음식 만족도',
    'Food Satisfaction',
    '食品满意度',
    '料理の満足度',
    'ความพึงพอใจในอาหาร',
    'Satisfacción con la comida',
    'Satisfaction alimentaire',
    'Удовлетворенность пищей',
    'Zufriedenheit mit dem Essen',
  ],
  review_registered: [
    '리뷰가 등록되었습니다.',
    'Your review has been registered.',
    '您的评论已注册。',
    'レビューが登録されました。',
    'รีวิวของคุณถูกลงทะเบียนแล้ว',
    'Su reseña ha sido registrada.',
    'Votre avis a été enregistré.',
    'Ваш отзыв был зарегистрирован.',
    'Ihre Bewertung wurde registriert.',
  ],
  delivery_satisfaction: [
    '배달 만족도',
    'Delivery Satisfaction',
    '配送满意度',
    '配達の満足度',
    'ความพึงพอใจในการจัดส่ง',
    'Satisfacción con la entrega',
    'Satisfaction de la livraison',
    'Удовлетворенность доставкой',
    'Zufriedenheit mit der Lieferung',
  ],
  text_review: [
    '맛있게 드셨다면 리뷰를 남겨주세요 (선택)',
    'If you enjoyed your meal, please leave a review (optional)',
    '如果您享受了您的餐，请留下评论（可选）',
    '美味しかったらレビューを残してください（任意）',
    'ถ้าคุณกินอร่อย โปรดเขียนรีวิว (เลือกได้)',
    'Si disfrutó de su comida, por favor deje una reseña (opcional)',
    'Si vous avez aimé votre repas, veuillez laisser un avis (facultatif)',
    'Если вам понравилась еда, оставьте отзыв (по желанию)',
    'Wenn es Ihnen geschmeckt hat, hinterlassen Sie bitte eine Bewertung (optional)',
  ],
  leave_review_label: [
    '리뷰 남기기',
    'Leave a Review',
    '留下评论',
    'レビューを残す',
    'เขียนรีวิว',
    'Dejar un comentario',
    'Laisser un avis',
    'Оставить отзыв',
    'Bewertung abgeben',
  ],
  zero_complaint_policy: [
    '고객 불만 제로 정책',
    'Zero Complaint Policy',
    '客户投诉零政策',
    '顧客苦情ゼロポリシー',
    'นโยบายการไม่มีข้อร้องเรียนจากลูกค้า',
    'Política de Quejas Cero',
    'Politique de Zéro Réclamation',
    'Политика нулевых жалоб',
    'Null-Beschwerde-Politik',
  ],
  zero_label: ['ZERO', 'ZERO', '零', 'ゼロ', 'ศูนย์', 'CERO', 'ZÉRO', 'НУЛЬ', 'NULL'],
  refund_policy: [
    '오배송/상품누락 시 100% 환불',
    '100% refund for wrong delivery/missing items',
    '错误配送/商品遗漏时100%退款',
    '誤配送/商品欠品時100%返金',
    'การคืนเงิน 100% ในกรณีส่งผิด/สินค้าหาย',
    'Reembolso del 100% por entrega incorrecta/artículos faltantes',
    "Remboursement à 100 % en cas de livraison incorrecte/d'articles manquants",
    '100% возврат при неверной доставке/недостающих товарах',
    '100 % Rückerstattung bei falscher Lieferung/fehlenden Artikeln',
  ],
  customer_service_message: [
    '배달이 잘못되었거나 음식에 문제가 있다면\n아래 노크노크 고객센터에 주문전호와 불만사항을 남겨주세요',
    'If your delivery is incorrect or there is an issue with the food,\nplease leave your order number and complaint at the Knock Knock customer service below.',
    '如果您的配送错误或食物有问题，请在下面的诺克诺克客服留下您的订单号和投诉内容。',
    '配達が間違っているか、食べ物に問題がある場合は、以下のノックノックカスタマーサービスに注文番号と苦情を残してください。',
    'หากการจัดส่งผิดหรือมีปัญหากับอาหาร โปรดทิ้งหมายเลขคำสั่งซื้อและข้อร้องเรียนของคุณที่ศูนย์บริการลูกค้าโน้กโน้กด้านล่าง',
    'Si su entrega es incorrecta o hay un problema con la comida,\ndeje su número de pedido y queja en el servicio al cliente de Knock Knock a continuación.',
    'Si votre livraison est incorrecte ou si vous avez un problème avec la nourriture,\nveuillez laisser votre numéro de commande et votre plainte au service client Knock Knock ci-dessous.',
    'Если доставка неверна или есть проблема с едой,\nпожалуйста, оставьте свой номер заказа и жалобу в службе поддержки клиентов Knock Knock ниже.',
    'Wenn die Lieferung falsch ist oder es ein Problem mit dem Essen gibt,\nhinterlassen Sie bitte Ihre Bestellnummer und Beschwerde beim Kundenservice von Knock Knock unten.',
  ],
  kakaotalk_link: [
    '카카오톡 바로가기',
    'KAKAKOTALK',
    'KAKAKOTALK',
    'KAKAKOTALK',
    'KAKAKOTALK',
    'KAKAKOTALK',
    'KAKAKOTALK',
    'KAKAKOTALK',
    'KAKAKOTALK',
  ],
  food_inquiry_message: [
    "* 음식 관련 문의는 주문하신 매장에 연락하시면 빠르게 해결돼요",
    "* For food-related inquiries, contacting the store you ordered from will provide a quick resolution.",
    "* 有关食品的查询，请联系您订购的商店，以便快速解决。",
    "* 食品に関するお問い合わせは、ご注文された店舗に連絡すると迅速に解決します。",
    "* หากมีข้อสงสัยเกี่ยวกับอาหาร สามารถติดต่อร้านค้าที่คุณสั่งได้ จะช่วยให้แก้ปัญหาได้รวดเร็ว",
    "* Para consultas relacionadas con alimentos, contactar a la tienda donde realizó el pedido solucionará rápidamente el problema.",
    "* Pour toute question concernant les aliments, contacter le magasin auprès duquel vous avez commandé permettra une résolution rapide.",
    "* По вопросам, связанным с продуктами питания, обращение в магазин, из которого вы заказали, быстро решит проблему.",
    "* Bei Fragen zu Lebensmitteln wenden Sie sich bitte an das Geschäft, bei dem Sie bestellt haben, um schnell eine Lösung zu finden."
  ],
  confirmation: [
    "확인",
    "Confirmation",
    "确认",
    "確認",
    "ยืนยัน",
    "Confirmación",
    "Confirmation",
    "Подтверждение",
    "Bestätigung"
  ],
};
